import React from "react";
import Solutions from "../components/pagescomponents/solutions/Solutions";
import Cta from "./../components/common/Cta";
import { useTheme } from "styled-components";
import Button from "./../components/common/Button";

import { Container, Flex } from "./../components/styleguide/layout";
import { H2, P } from "./../components/styleguide/typography";
import Transfer from "../components/pagescomponents/transfer/Transfer";

const About = () => {
  const theme = useTheme();
  return (
    <div className="about__section">
      <Container height="100vh" margin="8rem 0 0 0">
        <Flex
          items="center"
          height="100%"
          direction="column"
          justify="center"
          gap="1rem"
        >
          <H2 align="center" textTransform="uppercase">
            <span style={{ color: theme.colors.secondary }}>
              Made by Africans for Africa
            </span>
          </H2>
          <P maxWidth="650px"  margin= "5px auto 30px" align="center">
            Whether you are sending or spending a rand, cedi, naira, CFA franc,
            kwanza or pound MULA is here to make African transactions easy, fast
            & smooth.
          </P>

          <Button text="START USING MULA" variant="primary" to="" />
        </Flex>
      </Container>
      <Transfer/>
      <Solutions />
      <Cta />
    </div>
  );
};

export default About;
